/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DeploymentLogEvent,
  DeploymentLogEvent$inboundSchema,
} from "./deploymentlogevent.js";

export type GetDeploymentLogsResult = {
  /**
   * The logs for the deployment
   */
  events: Array<DeploymentLogEvent>;
  /**
   * The cursor to fetch results from
   */
  nextCursor?: string | undefined;
  /**
   * The status of the deployment
   */
  status: string;
};

/** @internal */
export const GetDeploymentLogsResult$inboundSchema: z.ZodMiniType<
  GetDeploymentLogsResult,
  unknown
> = z.pipe(
  z.object({
    events: z.array(DeploymentLogEvent$inboundSchema),
    next_cursor: z.optional(z.string()),
    status: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function getDeploymentLogsResultFromJSON(
  jsonString: string,
): SafeParseResult<GetDeploymentLogsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetDeploymentLogsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetDeploymentLogsResult' from JSON`,
  );
}
